export default "__VITE_ASSET__CTsJlS9s__"